import { OPEN_SLIPPAGE } from '@/client/confs/app';
import { useTradeSettingStore } from '@/client/store/trade-store';
import { useMemo } from 'react';

export const useTradeSettings = (amount?: bigint) => {
  const deadline = useTradeSettingStore(state => state.deadline);
  const slippage = useTradeSettingStore(state => state.slippage);
  const minAmount = useMemo(
    () => (amount && OPEN_SLIPPAGE ? (BigInt(amount) * BigInt(Math.ceil((1e2 - slippage) * 1e2))) / BigInt(1e4) : BigInt(0)),
    [amount, slippage]
  );
  const deadlineTime = useMemo(() => Math.ceil(Date.now() / 1e3) + Math.ceil(deadline) * 60, [deadline]);
  return {
    minAmount,
    deadlineTime,
  };
};
